import t from "../../../../helpers/t";
import React from "react";

const DayPrice = (props) => {
  const { priceLocal, onChangeForm } = props;
  return (
    <>
      <td className="weekday_price">
        <label style={{ float: "left" }}>{t("price", null, "capital")}</label>
        <input
          className="pricetariff-price input-group-field"
          type="text"
          name="alternative_amount"
          value={priceLocal.alternative_amount}
          onChange={(e) => onChangeForm(e)}
          style={{ float: "left", width: "60%", marginLeft: "5px" }}
        />
      </td>
      <td className="weekday_price standard-price-column" style={{ width: "140px" }}>
        <label style={{ float: "left" }}>{t("from the")}</label>
        <input
          className="pricetariff-price input-group-field weekpricefield"
          type="text"
          name="min_units"
          value={
            typeof priceLocal.min_units !== "undefined" &&
            priceLocal.min_units !== null &&
            priceLocal.min_units !== 0
              ? priceLocal.min_units
              : ""
          }
          onChange={(e) => onChangeForm(e)}
          style={{ float: "left", width: "30%", marginLeft: "5px", marginTop: "-5px" }}
        />
        <label>. {t("day_single")}</label>
      </td>
    </>
  );
};

export default DayPrice;
